import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

type LinkProps = Omit<RouterLinkProps, "to"> &
  Omit<ComponentPropsWithoutRef<"a">, "href"> & {
    href?: string;
    to?: RouterLinkProps["to"];
    children?: ReactNode;
  };

/** Drop-in for next/link — accepts `href` or `to`. */
export function Link({ href, to, children, ...props }: LinkProps) {
  return (
    <RouterLink to={to ?? href ?? "/"} {...props}>
      {children}
    </RouterLink>
  );
}

export default Link;
